module.exports = __webpack_public_path__ + "img/scan.49e0e82b.png";